var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTagsTag = function SvgTagsTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.172 3-9.586 9.586C2.208 12.964 2 13.466 2 14c0 .534.208 1.036.586 1.414l6 6c.378.378.88.586 1.414.586.534 0 1.036-.208 1.414-.586L21 11.828V3h-8.828ZM13 5h6v6l-9 9-6-6 9-9Zm3 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })));
};
export default SvgTagsTag;